import { Box, Button, Typography } from '@mui/material';
import styles from './AccessError.module.scss';
import keycloak from '../../keycloak';
import AccessErrorImage from '../../assets/images/AccessErrorImage';

const AccessError = () => {

  return (
    <Box id={styles.accessError}>
      <Box className={styles.accessErrorBody}>
        <Box>
          <AccessErrorImage />
        </Box>
        <Box className={styles.accessErrorInfo}>
          <Typography className={styles.accessErrorInfoTitle} variant='h3'>
            Access Restricted
          </Typography>
          <Typography className={styles.accessErrorInfoDescription}>
            You don't have the necessary permissions to view this page.<br />
            Please contact your administrator or sign in with a different account.
          </Typography>
          <Button style={{ width: '200px', borderRadius: '2px'}} size='large' onClick={() => keycloak.logout()}>
            Log out
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
export default AccessError;
